<template>
  <DTable
    @list-query="lm = $event"
    :initial="lm"
    :pagination="true"
    :homePage="true"
    :excludeDestructed="true"
    :page-size-options="[5, 10, 20, 50]"
    :persist-key="persistKey"
  />
</template>

<script setup>
import { ref, reactive, computed, watch, provide } from 'vue'
import { commons } from '@/lib/transformer'
import { useApi } from '@/composables/api'
import DTable from '@/views/destructions/list.vue'

const { persistKey = '' } = defineProps({
  persistKey: { type: String, default: '' },
})
const lm = ref({ onPage: 5, page: 1 })

const query = reactive({
  order_field: 'date_created',
  order_direction: 'DESC',
  filter: '',
  filter_id: '',
  search: '',
  onPage: 5,
  page: 1,
})

const apiQuery = computed(() => {
  const base = {
    filter: query.filter,
    filter_id: query.filter_id,
    onPage: query.onPage,
    page: query.page,
    exclude_destructed: true,
    ...(query.search ? { search: query.search } : {}),
  }

  if (query.filter === '' && query.filter_id === '') {
    return {
      ...base,
      order_field: query.order_field,
      order_direction: query.order_direction,
    }
  }

  return base
})

const { model, refresh } = useApi({
  url: 'destructions',
  data: { data: [], total_count: 0 },
  query: apiQuery,
  pick: d => {
    const _d = (d.data || []).map(d => {
      if (d.date_created) {
        d.fmt_date_created = commons.dateLocal(d.date_created, 'Pp')
      }
      return d
    })
    return { data: _d, total_count: d.total_count ?? _d.length }
  },
})

provide('model', model)
provide('refresh', refresh)

watch(
  lm,
  val => {
    Object.assign(query, val)
    refresh()
  },
  { immediate: true }
)
</script>
